import { createContext } from 'react'

import { createHomeStore } from '../store/createStore'

export const HomeStoreContext = createContext<
  ReturnType<typeof createHomeStore> | undefined
>(undefined)
